import { scrollToTop } from "@faire/help-center-utils/lib/window";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { assignHelpCenterSearchAndNavImprovements } from "@faire/help-center-utils/settings/getSettingHelpCenterSearchAndNavImprovements";
import { ContactStrategy } from "@faire/help-center/components/ContactStrategy/ContactStrategy";
import { ContactUsMainBanner } from "@faire/help-center/components/ContactUsBanner/ContactUsMainBanner";
import { Footer } from "@faire/help-center/components/PageWrapper/Footer/Footer";
import { SingleTopic } from "@faire/help-center/components/Section/SingleTopic";
import { useSectionStore } from "@faire/help-center/hooks/useSectionStore";
import { useTrackHelpCenterMainPagesView } from "@faire/help-center/hooks/useTrackHelpCenterMainPagesView";
import { trackHelpCenterHomePageView, trackHelpCenterHomePageViewTraceRendered } from "@faire/web-api/events/helpCenter/view/homePage";
import { markPageJsExecuted } from "@faire/web/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { useUserPerceivedLoadTimingWithKey } from "@faire/web/common/performance/userPerceivedLoadTiming/useUserPerceivedLoadTiming";
import React, { useEffect, useLayoutEffect } from "react";
import { EXPERIMENT } from "../eventEnum";
import { HomeHeader } from "./HomeHeader";
import { PopularGuides } from "./PopularGuides";
var PAGE_JS_EXECUTED_MARK = markPageJsExecuted();
export var HomePage = function HomePage() {
  var retailerToken = getRetailerToken();
  var brandToken = getBrandToken();
  var _useSectionStore = useSectionStore(),
    isLoading = _useSectionStore.isLoading,
    dataUpdatedAt = _useSectionStore.dataUpdatedAt;
  useEffect(function () {
    scrollToTop();
    trackHelpCenterHomePageView(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", brandToken !== null && brandToken !== void 0 ? brandToken : "");
  }, [brandToken, retailerToken]);
  useLayoutEffect(function () {
    trackHelpCenterHomePageViewTraceRendered();
  }, []);
  useTrackHelpCenterMainPagesView(EXPERIMENT.CONTROL);
  useEffect(function () {
    assignHelpCenterSearchAndNavImprovements();
  }, []);
  var loadTimingRef = useUserPerceivedLoadTimingWithKey({
    name: "help_center-page_homepage",
    pageLoadKey: "help_center-page_homepage",
    isPageLoading: isLoading,
    numComponents: 3,
    enableTrackPerformanceBreakdown: "internal-tracking",
    pageJsExecutedMark: PAGE_JS_EXECUTED_MARK,
    dataUpdatedAt: dataUpdatedAt
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HomeHeader, {
    loadTimingRef: loadTimingRef
  }), /*#__PURE__*/React.createElement(ContactStrategy, null), /*#__PURE__*/React.createElement(SingleTopic, {
    loadTimingRef: loadTimingRef
  }), /*#__PURE__*/React.createElement(PopularGuides, {
    loadTimingRef: loadTimingRef
  }), /*#__PURE__*/React.createElement(ContactUsMainBanner, {
    borderPosition: "top"
  }), /*#__PURE__*/React.createElement(Footer, null));
};